module.exports = __webpack_public_path__ + "static/transparency_report2022@2x-685d99a5835431c8e59c2cbc5e4ca5df.jpg";